import { Cloudinary } from 'cloudinary-core';

interface CreateOptimizedImageUriProps {
    src: string;
    height?: number | string;
    width?: number | string;
    quality?: number;
}

export function createOptimizedImageUri({ src, height, width, quality = 60 }: CreateOptimizedImageUriProps): string {
    const cld = new Cloudinary({
        cloud_name: 'totem-co',
        secure: true,
    });
    return cld.url(src, {
        height: height || 'auto',
        quality,
        type: 'fetch',
        width: width || 'auto',
    });
}
